<template>
    <div>
        <publish-filter :screens-data="screensData"
                        style="padding-inline: 16px; padding-block: 4px;"
                        @input="onFiltersChanged"
                        attach-dropdowns/>

        <p-data-table
            ref="dataTable"
            :expandedRows="expandedTableEntries"
            :loading="loading"

            :stateKey="dataTableStateKey"
            :value="tableEntries"
            class="datatable-expandable"
            columnResizeMode="fit"
            compareSelectionBy="equals"
            dataKey="id"
            loadingIcon="far fa-spinner-third fa-spin"
            removableSort
            responsiveLayout="scroll"

            stateStorage="local"

            @sort=""
            @value-change=""

            @state-restore="">

            <!--        :getEditLink="getEditLink"
            @clearFilters="clearFilters"-->

            <!--suppress VueUnrecognizedSlot -->
            <template #loading>
                <div class="table-text-center">{{ t_loading }}</div>
            </template>

            <!--suppress VueUnrecognizedSlot -->
            <template #empty>
                <table-empty-message
                    :filtersEmpty="filtersEmpty"
                    :message="noEntries ?  t_no_data_available_in_table : t_no_matching_records_found"
                    @clearFilters="clearFilters"
                />
            </template>

            <!--suppress VueUnrecognizedSlot -->
            <template #default>
                <column
                    :header="t_layer"
                    :showClearButton="false"
                    :showFilterMenu="false"
                    field="layer"
                    filterHeaderClass="column-narrow"
                    sortable>
                    <!--bodyClass="text-center"-->

                    <!--suppress VueUnrecognizedSlot -->
                    <template #body="{data, index}">
                        <div class="publish-dashlet-table-entry-title-container">
                            <element-state :state="data.state"
                                           colored-shadow
                                           size="small" />
                            <a :href="data.href">{{ data.layer }}</a>
                        </div>
                    </template>
                </column>

                <column
                    :header="t_resolution"
                    :showClearButton="false"
                    :showFilterMenu="false"
                    field="aspectRatio"
                    filterHeaderClass="column-narrow"
                    headerClass="sort-icon-numeric"
                    sortable>
                    <!--bodyClass="text-center"-->

                    <!--suppress VueUnrecognizedSlot -->
                    <template #body="{data}">
                        <!--                        <div class="tags-container">
                                                    <table-tag>-->
                        {{ data.resolution }}
                        <!--                            </table-tag>
                            </div>-->
                    </template>
                </column>

                <column
                    :header="t_duration"
                    :showClearButton="false"
                    :showFilterMenu="false"
                    field="duration"
                    filterHeaderClass="column-narrow"
                    headerClass="sort-icon-numeric"
                    sortable>
                    <!--bodyClass="text-center"-->

                    <!--suppress VueUnrecognizedSlot -->
                    <template #body="{data}">
                        {{ data.durationString }}
                    </template>
                </column>

                <column
                    :header="t_approved_elements_over_total_elements"
                    :showClearButton="false"
                    :showFilterMenu="false"
                    bodyClass="text-center"
                    field="unApprovedElements"
                    filterHeaderClass="column-narrow"
                    headerClass="sort-icon-numeric"
                    sortable>
                    <!--suppress VueUnrecognizedSlot -->
                    <template #body="{data}">
                        <v-chip
                            :color="data.stateColor"
                            :text-color="data.stateTextColor"
                            label
                            small>
                            <b>{{ data.approvedElements }} / {{ data.totalElements }}</b>
                        </v-chip>
                    </template>
                </column>
            </template>

            <!--suppress VueUnrecognizedSlot -->
            <template #expansion="{data: publishTableLayer}">
                <transition name="dashlet-previews-expand"
                            :appear="appearingTableRowsMap[publishTableLayer.index]">
                    <div v-if="nonEmptyTableEntriesMap[publishTableLayer.index]"
                         :style="{
                             'width': `${tableWidth}px`,
                             '--thumbnail-height-ul': thumbnailHeight
                         }"
                         class="publish-dashlet-table-entry-previews-container">
                        <template v-for="(element, elementIndex) in publishTableLayer.elements">
                            <transition :appear="appearingTableRowsMap[publishTableLayer.index]"
                                        name="adv-thumbnail-scale">
                                <provider-publish-table
                                    v-if="filteredElementIndicesArray[publishTableLayer.index][elementIndex]"
                                    :element="element"
                                    :layer="publishTableLayer">
                                    <advanced-thumbnail
                                        :alt="element.alt"
                                        :aspectRatio="publishTableLayer.aspectRatio"
                                        :href="element.href"
                                        :margin="false"
                                        min-width-for-state-and-icon>
                                        <element-preview-v2
                                            :previewHeight="thumbnailHeight"
                                            :size-ratio="layerSizeRatios[publishTableLayer.index]" />
                                    </advanced-thumbnail>
                                </provider-publish-table>
                            </transition>
                        </template>
                    </div>
                </transition>
            </template>
        </p-data-table>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Portal } from '@linusborg/vue-simple-portal'
import FilterAutocomplete from '../../../content/common/table/filter-autocomplete.vue'
import TableTag from '../../../content/common/table/table-tag.vue'
import TableCommon from '../../../content/common/table/table-common.vue'
import TableEditableName from '../../../content/common/table/table-editable-name.vue'
import SquareButton from '../../../content/common/squareButton.vue'
import ListDropdownMenu from '../../../content/common/list-dropdown-menu.vue'
import Column from '../../../content/common/PrimeVue/Column.vue'
import FilterSelect from '../../../content/common/table/filter-select.vue'
import AdvancedThumbnail from '../../../content/common/advanced-thumbnail.vue'
import TableSuperTag from '../../../content/common/table/table-super-tag.vue'
import PDataTable from '../../../content/common/PrimeVue/DataTable.vue'
import TableEmptyMessage from '../../../content/common/table/table-empty-message.vue'
import elementState from '../../../content/publish/elementstate.vue'
import ElementPreview from '../../../content/elements/elementPreview.vue'
import ElementPreviewV2 from '../../../content/elements/elementPreviewV2/elementPreviewV2.vue'
import PublishFilter from '../../../content/publish/publishFilter.vue'

import {
    adaptPublishLayer,
    checkElementSatisfiesFilters,
} from '../../../../../utils/publish'
import '../../../../../prototypeExtensions/String'
import { dateUSToDateISO } from '../../../../../utils/date'
import { printElementTypes } from '../../../../../utils/types'
import ProviderPublishTable from '../../../common/providers/providerPublishTable.vue'

export default defineComponent({
    name: 'publish-overview-table',
    components: {
        ProviderPublishTable,
        ElementPreviewV2,
        ElementPreview,
        elementState,
        PublishFilter,
        TableEmptyMessage,
        PDataTable,
        TableSuperTag,
        AdvancedThumbnail,
        FilterSelect,
        Column,
        ListDropdownMenu,
        SquareButton,
        TableEditableName,
        TableCommon,
        TableTag,
        FilterAutocomplete,
        Portal
    },
    props: {
        numEntries: {
            type: Number,
            required: true
        },
        /** @type {'small' | 'medium' | 'large'} */
        lineSize: String,
        /** @type {ScreensData} */
        screensData: Object
    },
    data() {
        return {
            loading: true,

            /** @type {PublishLayer[]} */
            publishLayers: null,
            showDeleted: JSON.parse(localStorage.getItem('publishEditorShowDeleted')),

            noEntries: true,

            localStorageKeyPrefix: 'dt-publish-dashlet',

            /** @type {?PublishFilters} */
            filters: null,

            resizeObserver: null,
            tableWidth: 0,

            /** @type {Record<number, PublishTableLayer>} */
            closingTableRowsMap: {},
            /** @type {Record<number, boolean>} */
            appearingTableRowsMap: {},
            /** @type {Record<number, PublishTableLayer>} */
            prevNonEmptyTableEntriesMap: {},
            noAppear: true,

            t_loading: Lang.langGet('Loading...'),
            t_no_matching_records_found: Lang.langGet('No matching records found.'),
            t_no_data_available_in_table: Lang.langGet('No data available in table.'),

            t_layer: Lang.langGet('Layer').capitalize(),
            t_resolution: Lang.langGet('Resolution').capitalize(),
            t_duration: Lang.langGet('Duration').capitalize(),
            t_approved_elements: Lang.langGet('Approved elements').capitalize(),
            t_total_elements: Lang.langGet('Total elements').capitalize()
        }
    },
    computed: {
        t_approved_elements_over_total_elements() {
            return `${this.t_approved_elements} / ${this.t_total_elements}`
        },
        dataTableStateKey() {
            return `${this.localStorageKeyPrefix}-state.${Laravel.activeUser}.${Laravel.activeProject}`
        },
        filtersEmpty() {
            if (!this.filters) return true

            return this.filters.screen == '' &&
                (this.filters.screengroup == '' /** TODO - ASK Peter **  || this.filters.screengroup == this.screensData.default_screengroup*/) &&
                this.filters.validTo == '' &&
                this.filters.validFrom == ''
        },
        /** @returns {PublishLayer[]} */
        /*filteredLayers() {

            /!** @type {AdaptedPublishFilters} *!/
            const adaptedFilters = {
                screen: this.filters?.screen || null,
                screengroup: this.filters?.screengroup || null,
                validFrom: this.filters?.validFrom ? new Date(dateUSToDateISO(this.filters.validFrom)) : null,
                validTo: this.filters?.validTo ? new Date(dateUSToDateISO(this.filters.validTo)) : null
            }

            const filtersNotEmpty = Object.values(adaptedFilters).some(filterValue => filterValue)

            return this.publishLayers?.map(publishLayer => {

                // Shallow copy of publish layer, so the below re-assignment of 'elements' does not affect original publishLayer's 'elements' (which are still needed intact if filters are removed for example)
                /!** @type {PublishLayer} *!/
                const mappedPublishLayer = { ...publishLayer }

                if (mappedPublishLayer.elements)
                    mappedPublishLayer.elements = mappedPublishLayer.elements.filter(element =>
                        !element.data.hidden &&
                        //!element.data.filter_hidden &&
                        filtersNotEmpty ? checkElementSatisfiesFilters(element.data, adaptedFilters, this.screensData.screengroupsToScreens) : true
                    )

                return mappedPublishLayer
            })
        },*/
        /** @type {Record<number, boolean>[]} */
        filteredElementIndicesArray() {

            /** @type {AdaptedPublishFilters} */
            const adaptedFilters = {
                screen: this.filters?.screen || null,
                screengroup: this.filters?.screengroup || null,
                validFrom: this.filters?.validFrom ? new Date(dateUSToDateISO(this.filters.validFrom)) : null,
                validTo: this.filters?.validTo ? new Date(dateUSToDateISO(this.filters.validTo)) : null
            }
            const filtersNotEmpty = Object.values(adaptedFilters).some(filterValue => filterValue)

            return this.publishLayers?.map(publishLayer => {
                const shownElementIndicesMap = {}
                publishLayer.elements?.forEach((element, index) => {
                    if (!element.data.hidden &&
                        (this.showDeleted ? true : (!['deleted', 'tobedeleted'].includes(element.state))) &&
                        //!element.data.filter_hidden &&
                        (filtersNotEmpty ? checkElementSatisfiesFilters(element.data, adaptedFilters, this.screensData.screengroupsToScreens) : true)) {
                        shownElementIndicesMap[index] = true;
                    }
                })

                return shownElementIndicesMap
            })
        },
        /** @returns {PublishTableLayer[]} */
        tableEntries() {
            return this.publishLayers?.map((publishLayer, layerIndex) => {
                return adaptPublishLayer(publishLayer, layerIndex, this.filteredElementIndicesArray[layerIndex], this.hrefForPublishLink)
            })
        },
        /** @returns {Record<number, PublishTableLayer>} */
        nonEmptyTableEntriesMap() {
            const map = {}
            this.tableEntries?.forEach(tableEntry => {
                if (tableEntry.totalElements)
                    map[tableEntry.index] = tableEntry
            })
            return map
        },
        /** @returns {PublishTableLayer[]} */
        expandedTableEntries() {
            return Object.values({ ...this.nonEmptyTableEntriesMap, ...this.closingTableRowsMap })
        },
        /** @returns {(number | null)[]} - Computed sizeRatios or null if height property is not available */
        layerSizeRatios() {
            // noinspection BadExpressionStatementJS - To make layerSizeRatios dependent on thumbnailHeight in case it's not read if filterpublishLayersedLayers are null
            this.thumbnailHeight

            return this.publishLayers?.map(publishLayer => publishLayer.height ? this.thumbnailHeight / publishLayer.height : null)
        },
        thumbnailHeight() {
            switch (this.lineSize) {
                default:
                case 'small':
                    return 48
                case 'medium':
                    return 80
                case 'large':
                    return 128
            }
        }
    },
    methods: {
        loadData() {
            this.loading = true
            this.$emit('error', false)

            axios.post('/content/publish/get', {
                project: Laravel.activeProject,
                layer: 'amount|' + this.numEntries
            }).then((response) => {
                response.data.data.forEach(publishLayer => {
                    publishLayer.name = publishLayer.name.replaceAmpGtLt()
                    publishLayer.fullname = publishLayer.fullname.replaceAmpGtLt()
                    publishLayer.fullname_size = publishLayer.fullname_size.replaceAmpGtLt()
                })
                this.publishLayers = response.data.data
                this.noEntries = !Array.isArray(this.publishLayers) || this.publishLayers.length === 0
            }).catch((error) => {
                if (error.response?.status === 401) {
                    window.location = '/login'
                }

                this.$emit('error', error)
            }).finally(() => {
                this.loading = false
                setTimeout(() => this.noAppear = false, 400)
            })
        },
        onFiltersChanged(filters) {
            this.filters = filters
        },
        clearFilters() {
            if (!this.filters) return
            Object.keys(this.filters).forEach(key => this.filters[key] = '')
        },
        hrefForPublishLink(layerId, elementIndex = -1) {
            return `/content/publish?layer=${layerId}${elementIndex >= 0 ? ('&element=' + elementIndex) : ''}`
        },
        destroyResizeObserver() {
            if (this.resizeObserver) this.resizeObserver.disconnect()
            this.resizeObserver = null
        }
    },
    watch: {
        loading(val) {
            this.$emit('loading', val)
        },
        /** @param val {Record<number, PublishTableLayer>} */
        nonEmptyTableEntriesMap(val) {

            /** @type {Record<number, PublishTableLayer>} */
            const closingEntriesMap = {}
            /** @type {Record<number, boolean>} */
            const appearingEntriesMap = {}

            Object.entries(this.prevNonEmptyTableEntriesMap).forEach(([prevEntryIndex, prevEntry]) => {
                if (!val[prevEntryIndex]) {
                    closingEntriesMap[prevEntryIndex] = prevEntry
                }
            })
            this.closingTableRowsMap = closingEntriesMap

            if (!this.noAppear) {
                Object.keys(val).forEach(entryIndex => {
                    if (!this.prevNonEmptyTableEntriesMap[entryIndex]) {
                        appearingEntriesMap[entryIndex] = true
                    }
                })
                this.appearingTableRowsMap = appearingEntriesMap
            }

            setTimeout(() => {
                this.closingTableRowsMap = {}
                this.appearingTableRowsMap = {}
            }, 355) // --thumbnail-transition-dimensions-duration is 350ms, plus a little margin

            this.prevNonEmptyTableEntriesMap = val
        }
        /** @param val {PublishLayer[]} */
        /*publishLayers(val) {
            printElementTypes(
                val.reduce((accumulator, currentLayer) => {
                    if (currentLayer.elements) accumulator.push(currentLayer.elements.map(element => element.data))
                    return accumulator
                }, []).flat()
            )
        }*/
    },
    created() {
        this.loadData()

        this.resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (!entry.contentBoxSize) return
                this.tableWidth = entry.contentBoxSize[0].inlineSize
            }
        })
    },
    mounted() {
        this.resizeObserver.observe(this.$refs.dataTable.$el)
    },
    beforeDestroy() {
        this.destroyResizeObserver()
    }
})
</script>

<style>
.publish-dashlet-table-entry-title-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.publish-dashlet-table-entry-previews-container {
    position: sticky;
    left: 0;

    display: flex;
    --publish-dashlet-previews-gap: 4px;
    gap: var(--publish-dashlet-previews-gap);
    overflow-x: auto;
    padding-inline: 16px;
    --publish-dashlet-previews-padding-block-start: 8px;
    --publish-dashlet-previews-padding-block-end: 12px;
    padding-block-start: var(--publish-dashlet-previews-padding-block-start);
    padding-block-end: var(--publish-dashlet-previews-padding-block-end);

    box-shadow: 0 20px 3px -21px rgba(0, 0, 0, 0.45) inset, 0 -20px 5px -23px rgba(0, 0, 0, 0.45) inset;
}
</style>
